module.exports = __webpack_public_path__ + "static/media/HN.1135f601.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/HN.svg
// module id = 2167
// module chunks = 7